import { BaseEntity } from "@planard/@core/base/BaseEntity";

export class CentralPlan extends BaseEntity {
  rows?: any[];
}
